import React, { Component } from 'react'
import { connect } from 'react-redux'
import TransitionGroup from 'react-addons-css-transition-group'

import { hideBanner } from '../redux/banners'
import classNames from './Banners.css'

class Banners extends Component {
  renderBanner = ({ id, text }) => {
    const onClick = () => this.props.hideBanner(id)
    return (
      <li key={id} className={classNames.banner} onClick={onClick}>
        {text}
      </li>
    )
  }
  render () {
    const { banners } = this.props
    const transitionName = {
      enter: classNames.enter,
      enterActive: classNames.enterActive,
      leave: classNames.leave,
      leaveActive: classNames.leaveActive
    }
    return (
      <TransitionGroup
        className={classNames.banners}
        component='ul'
        transitionName={transitionName}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={700}>
          {banners.map(this.renderBanner)}
      </TransitionGroup>
    )
  }
}

const mapStateToProps = ({ banners }) => ({
  banners
})

const mapDispatchToProps = {
  hideBanner
}

export default connect(mapStateToProps, mapDispatchToProps)(Banners)



// WEBPACK FOOTER //
// ./src/components/Banners.js